/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Tuda_Computer_Science19Inputs */

const en__field_enum_tuda_computer_science19 = /** @type {(inputs: _Field_Enum_Tuda_Computer_Science19Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Computer Science`)
};

const de__field_enum_tuda_computer_science19 = /** @type {(inputs: _Field_Enum_Tuda_Computer_Science19Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informatik`)
};

/**
* | output |
* | --- |
* | "Computer Science" |
*
* @param {_Field_Enum_Tuda_Computer_Science19Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_tuda_computer_science19 = /** @type {((inputs?: _Field_Enum_Tuda_Computer_Science19Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Tuda_Computer_Science19Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_tuda_computer_science19(inputs)
	return de__field_enum_tuda_computer_science19(inputs)
});
export { _field_enum_tuda_computer_science19 as "_field_enum_TUDA_COMPUTER_SCIENCE" }